export default {
  personalProfile: "Personal record",
  myAccount: "My account",
  back_to_my_account: "Back to my account",
};
